import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountCommonModule } from '@inyova/account-common';
import { TranslateModule } from '@ngx-translate/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReportingEffects } from './reporting.effects';
import * as fromReporting from './reporting.reducers';

import { SharedModule } from '@shared/shared.module';

import * as fromComponents from './components';
import { ReportingRoutingModule } from './reporting-routing.module';
import { ReportingComponent } from './reporting.component';

@NgModule({
  imports: [
    ReportingRoutingModule,
    TranslateModule,
    EffectsModule.forFeature([ReportingEffects]),
    StoreModule.forFeature(fromReporting.REPORTING_REDUCER_FEATURE_KEY, fromReporting.reducer),
    SharedModule,
    CommonModule,
    AccountCommonModule
  ],
  exports: [],
  declarations: [ReportingComponent, ...fromComponents.components],
  providers: []
})
export class ReportingModule {}
